<template>
  <div id="serverMonitoringWrapper">
    <div class="title-box">
      <span class="iconfont ys-iconbijibendiannaolaptop"></span>&nbsp;&nbsp;
      <span>今日实时统计</span>
    </div>
    <!-- 数字记录栏 -->
    <div class="nunber-box" v-if="allTimeData">
      <div class="every-box">
        <!-- 左 -->
        <div class="left"><span class="iconfont ys-iconfangdajing"></span></div>
        <div class="right">
          <p><span>{{allTimeData.totalQueryCount || 0}}</span></p>
          <p>总查询量</p>
        </div>
      </div>
      <div class="every-box">
        <!-- 左 -->
        <div class="left"><span class="iconfont ys-iconlifangtizu"></span></div>
        <div class="right">
          <p><span>{{allTimeData.totalAnswerCount || 0}}</span></p>
          <p>总应答量</p>
        </div>
      </div>
      <div class="every-box">
        <!-- 左 -->
        <div class="left"><span class="iconfont ys-iconshangyiji"></span></div>
        <div class="right">
          <p><span>{{allTimeData.totalQueryUpstreamCount || 0}}</span></p>
          <p>查询上游次数</p>
        </div>
      </div>
      <div class="every-box">
        <!-- 左 -->
        <div class="left"><span class="iconfont ys-iconyunduan"></span></div>
        <div class="right">
          <p><span>{{allTimeData.totalCachedCount || 0}}</span></p>
          <p>总缓存量</p>
        </div>
      </div>
    </div>
    <!-- echart -->
    <div class="echart-box">
      <div style="width: 100%;overflow: hidden;">
      <div id="echartLopp" style="width: 100%;height: 400px"></div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="bottom-box">
      <div class="left" v-if="list && list.length > 0">
        <!-- title部分 -->
        <div class="titles-box">
          <span class="iconfont ys-iconfl-renyuan"></span>&nbsp;&nbsp;
          <span>今日查询来源IP TOP10</span>
        </div>
        <div class="content-box">
          <div class="every-list">
            <div>
              <span>#</span>&nbsp;&nbsp;&nbsp;&nbsp;
              <span>IP</span>
            </div>
            <div>查询次数</div>
          </div>
          <div class="every-list" v-for="(item, index) in list" :key="index">
            <div>
              <span>{{index + 1}}</span>&nbsp;&nbsp;
              <span>{{item.ip}}--{{item.indexs}}</span>
            </div>
            <div>{{item.queryCount}}</div>
          </div>
        </div>
      </div>
      <div class="right" v-if="source && source.length > 0">
        <!-- title部分 -->
        <div class="titles-box">
          <span class="iconfont ys-iconxingxingbanke"></span>&nbsp;&nbsp;
          <span>今日查询域名 TOP10</span>
        </div>
        <div class="content-box">
          <div class="every-list">
            <div>
              <span>#</span>&nbsp;&nbsp;&nbsp;&nbsp;
              <span>域名</span>
            </div>
            <div>查询次数</div>
          </div>
          <div class="every-list" v-for="(item, index) in source" :key="index">
            <div>
              <span>{{index + 1}}</span>&nbsp;&nbsp;
              <span>{{item.name}}</span>
            </div>
            <div>{{item.queryCount}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex"
export default {
  data() {
    return {
      list: [],
      source: [],
      // echartsData: [["0:00",116],["0:30",129],["0:46",135],["1:20",86],["1:40",73],["2:00",85],["2:30",73],["2:40",68],["3:04",92],["3:15",130],["3:30",245],["3:52",139],["4:00",115]],
      echartsData: [],
      allTimeData: null, // 实时数据
      timers: '', // 延时器
    }
  },
  methods: {
    ...mapActions([
      'summaryNumber', // 实时数据
      'everyMinuteQueries', // 折线图数据
      'topQueryClients', // ip数据
      'topQueryNames', // 域名数据
    ]),
    leiDaNewDraw() {
      let leidaEchart = this.$echarts.init(document.getElementById('echartLopp'))
      leidaEchart.clear();
      var option = {
        title: {
            text: '今日每分钟查询量',
            textStyle: {
              color: '#fff'
            },
            top:10,
            left:10,
        },
        tooltip: {
            trigger: 'axis'
        },
        backgroundColor:'#2f3d57',
        grid: {
          left: '5%',
          right: '6%'
        },
        xAxis: {
            // 现在坐标系刻度最大值、最小值
            axisLabel: {
                showMinLabel: true,
                showMaxLabel: true,
            },
            data: this.echartsData.map(function(item) {
                return item.riqi;
            }),
            nameTextStyle: {

            },
            axisLabel: {
              color: '#fff'
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            splitNumber : 1,
        },
        yAxis: {
            splitLine: {
                show: true
            },
            axisLabel: {
              color: '#fff',
              
            },
            splitNumber : 8,
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            }
        },
        dataZoom: [{
            startValue: '2014-06-01'
        }, {
            type: 'inside'
        }],
        visualMap: {
            show: false,
            top: 10,
            right: 10,
            pieces: [ {
                gt: 0,
                lte: 400,
                color: '#cc0033'
            }],
            outOfRange: {
                color: '#999'
            }
        },
        series: {
            // name: 'Beijing AQI',
            type: 'line',
            data: this.echartsData.map(function(item) {
                return item.count;
            }),
        }
      }
      leidaEchart.setOption(option)
      window.addEventListener("resize", function() {
        leidaEchart.resize();
      });
    },
    // 实时数据
    async summaryNumbers() {
      try {
        const data = await this.summaryNumber();
        if (data.data.error.code === 0) {
          this.allTimeData = data.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 折线图数据
    async everyMinuteQueriesItem() {
      try {
        const data = await this.everyMinuteQueries();
        if (data.data.error.code === 0) {
          this.echartsData = data.data.data;
          // 调用折线图
          this.leiDaNewDraw();
        }
      } catch (error) {
        console.log(error);
      }
    },
    // ip数据
    async topQueryClientsItem() {
      try {
        const data = await this.topQueryClients();
        if (data.data.error.code === 0) {
          this.list = data.data.data || [];
          console.log(this.list, 'list')
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取域名数据
    async topQueryNamesItem() {
      try {
        const data = await this.topQueryNames();
        if (data.data.error.code === 0) {
          this.source = data.data.data || [];
          console.log(this.source, 'sourece')
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  destroyed() {
    clearTimeout(this.timers);
  },
  mounted() {
    this.summaryNumbers();
    this.everyMinuteQueriesItem();
    this.topQueryClientsItem();
    this.topQueryNamesItem();
    this.timers = setInterval(() => {
      this.summaryNumbers();
      this.everyMinuteQueriesItem();
      this.topQueryClientsItem();
      this.topQueryNamesItem();
    }, 40000);
  }
}
</script>
<style lang="less" scoped>
#serverMonitoringWrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px 0px;
  box-sizing: border-box;
  .title-box {
    width: 100%;
    padding: 0 50px;
    box-sizing: border-box;
    height: 40px;
    line-height: 40px;
    font-size: 24px;
    color: #fff;
    margin-bottom: 20px;
    span:nth-of-type(1) {
      font-size: 24px;
    }
  }
  .nunber-box {
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding: 0 50px;
    box-sizing: border-box;
    .every-box {
      width: 25%;
      margin-right: 26px;
      height: 150px;
      display: flex;
      flex-wrap: nowrap;
      padding: 0 40px;
      box-sizing: border-box;
      .left {
        line-height: 150px;
        span {
          font-size: 60px;
          color: #fff;
        }
      }
      .right {
        padding: 44px 20px;
        box-sizing: border-box;
        p:nth-of-type(1) {
          font-size: 18px;
          color: #fff;
          margin-bottom: 10px;
        }
        p:nth-of-type(2) {
          font-size: 12px;
          color: #fff;
        }
      }
    }
    .every-box:nth-of-type(1) {
      background-color: #d95043;
    }
    .every-box:nth-of-type(2) {
      background-color: #26c281;
    }
    .every-box:nth-of-type(3) {
      background-color: #57889c;
    }
    .every-box:last-child {
      margin-right: 0px;
      background-color: #e65097;
    }
  }
  .echart-box {
    width: 100%;
    padding: 0 50px;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 20px;
  }
  .bottom-box {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    padding: 0 50px;
    box-sizing: border-box;
    .left,.right {
      width: 50%;
      padding: 10px 0;
      box-sizing: border-box;
      background-color: #2f3d57;
      .titles-box {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        span:nth-of-type(1) {
          font-size: 12px;
          color: #fff;
        }
        span:nth-of-type(2) {
          font-size: 14px;
          color: #fff;
        }
      }
      .content-box {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        .every-list {
          width: 100%;
          border-bottom: 1px solid #ffffff;
          padding: 10px 0px;
          box-sizing: border-box;
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-between;
          padding: 10 20px;
          box-sizing: border-box;
          div{
            font-size: 14px;
            color: #fff;
          }
        }
      }
    }
    .left {
      margin-right: 20px;
    }
    .right {
      margin-right: 0px;
    }
  }
}
</style>